module.exports = __webpack_public_path__ + "img/1529480492.02c64599.jpg";